import type { ApiConfig } from '../../types'

export const stakingRewardHistoryApiConfig = {
  existSubType: false, // Sub Type: なし
  fetchableRange: undefined, // 制限なし
  limit: 500, // Limit: 500
  order: 'desc', // Order: desc
  range: undefined, // Range: 制限なし
  requiresRange: false, // from/to パラメータ不要 (API Request Parameters に範囲指定項目なし)
  type: 'staking-reward-history', // Type
} as const satisfies ApiConfig
